import { Component, computed, inject, input, signal, ChangeDetectionStrategy } from '@angular/core';

import { LocalStorageService } from '@core/common-legacy';
import { TranslatePipe } from '@core/i18n-legacy';
import { SkillDetails } from '@core/positions-and-skills-types';
import { CollapsibleCardComponent, HeadingComponent } from '@core/user-interface-legacy';

import { JobSkillSummaryComponent } from './job-skill-summary/job-skill-summary.component';

@Component({
  selector: 'rt-job-skills-summary-details-skills-section',
  templateUrl: 'job-skills-summary-details-skills-section.component.html',
  styleUrls: ['./job-skills-summary-details-skills-section.component.less'],
  changeDetection: ChangeDetectionStrategy.Eager,
  imports: [HeadingComponent, TranslatePipe, CollapsibleCardComponent, JobSkillSummaryComponent],
})
export class JobSkillsSummaryDetailsSkillsSectionComponent {
  private readonly localStorageService = inject(LocalStorageService);

  public readonly jobSkillsDetails = input.required<SkillDetails[]>();
  public readonly jobId = input.required<number>();
  public readonly candidateId = input.required<number>();

  protected enforceSkillsCardCollapsed = signal(
    this.localStorageService.get('enforce-skills-card-collapsed', true),
  );

  protected jobSkillsUniqKey = computed(
    () => `candidate-${this.candidateId()}-job${this.jobId()}-skills-card`,
  );

  protected jobSkillUniqKey(skillId: number) {
    return `candidate-${this.candidateId()}-job${this.jobId()}-skill-${skillId}-card`;
  }

  protected onCollapse(collapsed: boolean) {
    this.localStorageService.set('enforce-skills-card-collapsed', collapsed).then();
  }
}
